import { graphql } from "../generated";

export const MUTATE_SEND_VERIFICATION_EMAIL = graphql(`
  mutation MutateSendVerificationEmail($id: String!) {
    sendVerificationEmail(id: $id)
  }
`);
